import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { LoginScreen } from '@/pages/LoginScreen'
import { AdminLayout } from '@/components/AdminLayout'
import { DashboardPage } from '@/pages/DashboardPage'
import { OrganizationsPage } from '@/pages/OrganizationsPage'
import { OrganizationDetailPage } from '@/pages/OrganizationDetailPage'
import { UsersPage } from '@/pages/UsersPage'
import { UserDetailPage } from '@/pages/UserDetailPage'
import { SubscriptionsPage } from '@/pages/SubscriptionsPage'
import { StoragePage } from '@/pages/StoragePage'
import { AuditPage } from '@/pages/AuditPage'
import { ConnectionsPage } from '@/pages/ConnectionsPage'
import { SystemPage } from '@/pages/SystemPage'
import { DatabasePage } from '@/pages/DatabasePage'

export default function App() {
  const { user, loading, isAuthenticated } = useAuth()
  if (loading) return <div className="p-8 text-muted-foreground">Loading…</div>
  if (!isAuthenticated || !user?.isPlatformAdmin) return <LoginScreen />
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/orgs" element={<OrganizationsPage />} />
        <Route path="/orgs/:id" element={<OrganizationDetailPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:id" element={<UserDetailPage />} />
        <Route path="/billing" element={<SubscriptionsPage />} />
        <Route path="/storage" element={<StoragePage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/connections" element={<ConnectionsPage />} />
        <Route path="/database" element={<DatabasePage />} />
        <Route path="/system" element={<SystemPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AdminLayout>
  )
}
